module.exports = __webpack_public_path__ + "static/media/Lapras_gaussian2.30dd7329.png";